import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  typography: {
    fontFamily: "HN-Regular",
    secondaryFont: "HN-Bold",
    fontDisplay: "swap",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1140,
      xl: 1920,
    },
  },
  palette: {
    brand: {
      primary: {
        key: "#191919",
        light: "#F8F8F8",
        medium: "#8D8D8D",
        dark: "#494949",
      }
    },
    neutral: {
      primary: {
        key: "#FFFFFF",
        light: "#F8F8F8",
        medium: "#D9D9D9",
        dark: "#454545",
      },
      secondary: {
        key: "#191919",
        light: "#C3C3C3",
        medium: "#6E6E6E",
        dark: "#272727",
      }
    },
    feedback: {
      success: {
        key: "#62980E",
        light: "#F0FFDA",
        medium: "#62980E",
        dark: "#62980E",
      },
      error: {
        key: "#E42436",
        light: "#FFF1F3",
        medium: "#E42436",
        dark: "#E42436",
      }
    },
    transparent: "transparent",
  },
  gradient: "linear-gradient(180deg, rgba(48,149,222,0.20) 0%, rgba(94,199,241,0.00) 100%)",
  modalGradient: "rgba(0,0,0,0.70)",
  transition: "all ease 0.2s",
});

export default theme;
